import { API_HOST } from '../../config';

export const supportUserLogo = `${API_HOST}/images/support-user-logo.png`;
export const defaultUserLogo = `${API_HOST}/images/default-user-logo.png`;

export const getUserPhoto = user => (user.image && user.image.src) || user.photo || defaultUserLogo;
